import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Hook to load content blocks for a page
export const useContent = (page, defaults = {}) => {
  const [content, setContent] = useState(defaults);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!page) return;
    axios.get(`${API}/public/content/${page}`)
      .then(r => {
        if (r.data && Object.keys(r.data).length > 0) {
          setContent(prev => ({ ...prev, ...r.data }));
        }
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [page]);

  return { content, loaded };
};

// Hook to load content list (partners, KPIs, industries, etc.)
export const useContentList = (page, defaults = []) => {
  const [items, setItems] = useState(defaults);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!page) return;
    axios.get(`${API}/public/content-list/${page}`)
      .then(r => {
        if (r.data && r.data.length > 0) {
          setItems(r.data);
        }
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [page]);

  return { items, loaded };
};
